import { Component } from "@angular/core";
import { ConciergeService } from "../../services/concierge.service";
import { ClockComponent } from "@apps/patient-core/src/app/components/clock/clock.component";
import { ModalComponent } from "@apps/patient-core/src/app/components/modal/modal.component";
import { SkeletonDefaultComponent } from "@apps/patient-core/src/app/components/skeletons/skeleton-default/skeleton-default.component";
import { SkeletonLoaderComponent } from "@apps/patient-core/src/app/components/skeletons/skeleton-loader/skeleton-loader.component";

@Component({
  selector: "dentr-diagnostics",
  templateUrl: "./diagnostics.component.html",
  standalone: true,
  imports: [ModalComponent, SkeletonDefaultComponent, SkeletonLoaderComponent, ClockComponent],
})
export class DiagnosticsComponent {
  constructor(private _conciergeService: ConciergeService) {}

  get diagnosticsData() {
    const { diagnosticsData } = this._conciergeService;
    if (!diagnosticsData) return [];

    return Object.keys(diagnosticsData).map((key) => ({
      key: this._formatKey(key),
      value: diagnosticsData[key],
    }));
  }

  private _formatKey(key: string): string {
    if (key.toLowerCase() === "id") {
      return "Device ID";
    }

    return key
      .replace(/_/g, " ") // Replace underscores with spaces
      .replace(/\b\w/, (char) => char.toUpperCase()) // Capitalize the first word
      .replace(/\b(?:id)\b/gi, "ID") // Replace 'id' with 'ID'
      .replace(/\b(?:jwt)\b/gi, "JWT"); // Replace 'jwt' with 'JWT'
  }
}
